import { Badge, IconButton, makeStyles } from '@material-ui/core';
import { useLocalStorage } from 'api/useLocalStorage';
import React from 'react';
import { isNullUndEmpty } from 'utils/general';

import { RenderResourceMenuItemLink, translatedResourceName } from './Menu';

const useStyles = makeStyles({
	customBadgeUnviewed: {
		backgroundColor: "#e74c3c",
		color: "white",
	},
	customBadgeTotal: {
		backgroundColor: "rgb(119, 136, 153, 0.8)",
		color: "white",
	},
	iconButton: {
		paddingLeft: 10,
		paddingRight: 10,
	},
});

const RenderCounterBadge = ({ viewedCount, unviewedCount }) => {
	const classes = useStyles();

	let messageCountStyle = {badge: classes.customBadgeTotal};
	let messageCount = viewedCount;
	if (unviewedCount > 0) {
		messageCountStyle = {badge: classes.customBadgeUnviewed};
		messageCount = unviewedCount;
	}

	return (
		<IconButton classes={classes.iconButton}>
			<Badge 
				classes={messageCountStyle} 
				badgeContent={messageCount} 
				showZero 
			/>
		</IconButton>
	);
};

const CounterBadge = () => {
	const { user_data_draft_orders = {} } = useLocalStorage();
	const { 
		viewed_count: viewedCount = null, 
		unviewed_count: unviewedCount = null
	} = user_data_draft_orders;

	if (
		isNullUndEmpty(viewedCount) || 
		isNullUndEmpty(unviewedCount)
	) {
		return null;
	}

	return (
		<RenderCounterBadge 
			viewedCount={viewedCount} 
			unviewedCount={unviewedCount} 
		/>
	);
};

const PrimaryText = ({ menuItemName }) => (
	<div>
		<span>{menuItemName}</span>
		&nbsp;
		<span><CounterBadge /></span>
	</div>
);

export const DraftOrdersMenuItem = ({ translate, resource, ...rest }) => {
	const menuItemName = translatedResourceName(resource, translate);

	return (
		<RenderResourceMenuItemLink 
			{...rest} 
			resource={resource}
			translate={translate}
			primaryText={<PrimaryText menuItemName={menuItemName} />} 
		/>
	);
};